<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-account-group
            </v-icon>
            <span class="title">Data Mitra</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Mitra
              <v-icon large>mdi-account-group</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Judul"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editdata(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              @click="deletedata(item)"
                              small
                              icon>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formadddata"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" md="11">
                          <v-row>
                            <v-col cols="12" md="7">
                              <v-text-field
                                v-model="adddata.mitra_name"
                                :rules="[rules.required]"
                                label="Nama mitra"
                                name="namamitra"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="5">
                              <v-text-field
                                v-model="adddata.mitra_bidang"
                                :rules="[rules.required]"
                                label="Bidang"
                                name="bidangmitra"
                                placeholder="Ex: Pariwisata"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                              <v-select
                                :items="mitratype"
                                name="typemitra"
                                v-model="adddata.mitra_type"
                                label="Type">
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="adddata.mitra_loc"
                                :rules="[rules.required]"
                                label="Lokasi mitra"
                                placeholder="ex: Denpasar"
                                name="website"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="5">
                              <v-text-field
                                v-model="adddata.mitra_web"
                                :rules="[rules.required]"
                                label="Alamat website"
                                placeholder="Ex: https://pnb.ac.id"
                                name="website"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                name="prev"
                                label="Preview mitra (Max 300 Karakter)"
                                placeholder="Tuliskan preview mitra disini..."
                                counter
                                rows="3"
                                v-model="adddata.mitra_prev"
                                :rules="[rules.required, rules.textlimit]">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-file-input
                                v-model="adddata.mitra_pic"
                                :rules="rules.files"
                                accept=".png, .jpg, .jpeg"
                                name="filecover"
                                placeholder="Select file"
                                label="Image Thumbnail (max. 500 Kb)"
                                show-size
                                prepend-icon="mdi-camera">
                              </v-file-input>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <vue-editor
                                v-model="adddata.mitra_desc"
                                placeholder="Tuliskan deskripsi mitra disini..."
                                :rules="[rules.required]">
                              </vue-editor>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                :color="maincolor"
                                dark
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.updata"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.updata">
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update data jurnal
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.updata = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="11">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdate"
                    ref="formupdatedate"
                    v-model="formupdate.valid"
                    lazy-validation>
                    <v-row justify="center">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="7">
                            <v-text-field
                              v-model="dmodaldata.updata.mitra_name"
                              :rules="[rules.required]"
                              label="Judul"
                              name="judul"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <v-text-field
                              v-model="dmodaldata.updata.mitra_bidang"
                              :rules="[rules.required]"
                              label="Bidang"
                              name="bidangmitra"
                              placeholder="Ex: Pariwisata"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              :items="mitratype"
                              name="typemitra"
                              v-model="dmodaldata.updata.mitra_type"
                              label="Type">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="dmodaldata.updata.mitra_loc"
                              :rules="[rules.required]"
                              label="Lokasi mitra"
                              placeholder="ex: Denpasar"
                              name="website"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <v-text-field
                              v-model="dmodaldata.updata.mitra_web"
                              :rules="[rules.required]"
                              label="Alamat website"
                              placeholder="Ex: https://pnb.ac.id"
                              name="website"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              name="prev"
                              label="Preview mitra (Max 300 Karakter)"
                              placeholder="Tuliskan preview mitra disini..."
                              counter
                              rows="3"
                              v-model="dmodaldata.updata.mitra_prev"
                              :rules="[rules.required, rules.textlimit]">
                            </v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <vue-editor
                              v-model="dmodaldata.updata.mitra_desc"
                              placeholder="Tuliskan deskripsi mitra disini..."
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              v-if="dmodaldata.updata.mitra_pic"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="api + '/upload/mitra/' + dmodaldata.updata.mitra_pic"
                              contain>
                            </v-img>
                            <v-img
                              v-if="!dmodaldata.updata.mitra_pic"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="require('../../assets/default.jpg')"
                              contain>
                            </v-img>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="dmodaldata.updata.mitra_picnew"
                              :rules="rules.files"
                              accept=".png, .jpg, .jpeg"
                              name="filecover"
                              placeholder="Select file"
                              label="Image Thumbnail (max. 500 Kb)"
                              show-size
                              prepend-icon="mdi-camera">
                            </v-file-input>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <alertsp :alertdata="alertupdate"></alertsp>
                            <v-btn
                              block
                              large
                              :disabled="loading.updata || !formupdate.valid"
                              :loading="loading.updata"
                              :color="maincolor"
                              dark
                              type="submit">
                              Simpan
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- delete -->
    <v-dialog
      v-model="dmodal.deldata"
      max-width="450px">
      <v-card v-if="dmodaldata.deldata">
        <v-card-title>
          <span>Hapus data mitra</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.deldata = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div>
            Apakah anda yakin menghapus data mitra?
            <p>
              <b>{{ dmodaldata.deldata.mitra_name }}</b>
            </p>
            <!-- <span class="green--text" v-html="msgcopy"></span> -->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2 mb-3"
            color="error"
            dark
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemove(dmodaldata.deldata)">
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';

export default {
  name: 'Mitraadmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      remove: false,
      update: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listtype: ['berita', 'agenda', 'pengumuman', 'file'],
    mitratype: ['Local', 'National', 'International'],
    listlang: ['id', 'en'],
    listcategory: ['pnb', 'pendidikan', 'penelitian', 'pengabdian', 'kerjasama', 'mahasiswa', 'bali', 'covid', 'pendaftaran', 'pkkmb', 'zi-wbk'],
    listfav: ['tidak', 'ya'],
    filter: {
      search: '',
      type: '',
    },
    headers: [
      { text: 'Nama', value: 'mitra_name' },
      { text: 'Bidang', value: 'mitra_bidang' },
      { text: 'Website', value: 'mitra_web' },
      { text: 'Type', value: 'mitra_type' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    adddata: {
      mitra_name: '',
      mitra_prev: '',
      mitra_desc: '',
      mitra_web: '',
      mitra_bidang: '',
      mitra_video: '',
      mitra_loc: '',
      mitra_type: 'Local',
      mitra_pic: null,
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 300 || 'Max 300 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      updata: false,
      deldata: false,
    },
    dmodaldata: {
      updata: null,
      deldata: null,
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addtglberita: false,
      addtglevent: false,
      updatetglberita: false,
      updatetglevent: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getData();
    this.adddata.jo_lang = this.listlang[0];
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    updateDate() {
      this.datepick.addtglberita = false;
      if (Date.parse(this.adddata.tgl_berita) > Date.parse(this.adddata.tgl_end)) {
        this.adddata.tgl_end = this.adddata.tgl_berita;
      }
    },
    updateDateEvent() {
      this.datepick.updatatglberita = false;
      if (Date.parse(this.dmodaldata.updata.tgl_berita) > Date.parse(this.dmodaldata.updata.tgl_end)) {
        this.dmodaldata.updata.tgl_end = this.dmodaldata.updata.tgl_berita;
      }
    },
    getData() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/mitra/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        if (this.tokenscr) {
          const dataadd = this.adddata;
          const formData = new FormData();
          // file image
          // formData.append('logo_olga', dataadd.logo_olga);
          // data olga
          formData.append('mitra_name', dataadd.mitra_name);
          formData.append('mitra_bidang', dataadd.mitra_bidang);
          formData.append('mitra_prev', dataadd.mitra_prev);
          formData.append('mitra_desc', dataadd.mitra_desc);
          formData.append('mitra_web', dataadd.mitra_web);
          formData.append('mitra_video', dataadd.mitra_video);
          formData.append('mitra_loc', dataadd.mitra_loc);
          formData.append('mitra_pic', dataadd.mitra_pic);
          formData.append('mitra_type', dataadd.mitra_type);
          this.axios
            .post(
              this.api + '/api/mitra/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formadddata.reset();
                  this.adddata.mitra_desc = '';
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Mitra "' + resdata.data + '" berhasil ditambahkan!';
                  this.getData();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    editdata(item) {
      this.dmodal.updata = true;
      this.alertupdate.show = false;
      this.dmodaldata.updata = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatedate.validate()) {
        if (this.tokenscr) {
          this.loading.updata = true;
          const dataadd = this.dmodaldata.updata;
          const formData = new FormData();
          // file
          // formData.append('logo_olganew', dataadd.logo_olganew);
          // data
          // console.log(dataadd);
          formData.append('mitra_name', dataadd.mitra_name);
          formData.append('mitra_bidang', dataadd.mitra_bidang);
          formData.append('mitra_prev', dataadd.mitra_prev);
          formData.append('mitra_desc', dataadd.mitra_desc);
          formData.append('mitra_id', dataadd.mitra_id);
          formData.append('mitra_web', dataadd.mitra_web);
          formData.append('mitra_video', dataadd.mitra_video);
          formData.append('mitra_loc', dataadd.mitra_loc);
          formData.append('mitra_type', dataadd.mitra_type);
          formData.append('mitra_pic', dataadd.mitra_pic);
          formData.append('mitra_picnew', dataadd.mitra_picnew);
          this.axios
            .post(
              this.api + '/api/mitra/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = '"' + this.dmodaldata.updata.mitra_name + '" berhasil diubah!';
                  this.getData();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updata = false;
            })
            .catch((error) => {
              this.loading.updata = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.loading.updata = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    deletedata(item) {
      this.dmodal.deldata = true;
      this.alertupdate.show = false;
      this.dmodaldata.deldata = JSON.parse(JSON.stringify(item));
    },
    confirmRemove(item) {
      // console.log(item);
      this.alertupdate.show = false;
      if (this.tokenscr && item) {
        // console.log(item);
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/mitra/' + item.mitra_id,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.deldata = false;
                this.dmodaldata.deldata = null;
                this.getData();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token, please refresh first!';
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
